<mat-dialog-content>
  @if (
    companyId == '1' ||
    companyId == '2' ||
    companyId == '5' ||
    companyId == '6' ||
    companyId == '7' ||
    companyId == '8' ||
    companyId == '9'
  ) {
    <form>
      <h2>
        <strong>{{ 'Delivery' | translate }}</strong>
      </h2>
      <div class="text-margin">
        <span
          ><strong>{{ 'Send to' | translate }}:</strong></span
        >
        <input
          class="form-control"
          [(ngModel)]="deliveryTxt"
          type="text"
          name="deliveryTxt"
          autocomplete="off"
        />
      </div>
      <div style="margin-bottom: 20px">
        <button mat-raised-button (click)="validation(1)" mat-dialog-close>
          {{ 'Save Changes' | translate }}
        </button>
        <button mat-raised-button mat-dialog-close>
          {{ 'Close' | translate }}
        </button>
      </div>
    </form>
  }

  @if (companyId == '4') {
    <form [formGroup]="registerForm">
      <h3>
        <strong>{{ 'Delivery' | translate }}</strong>
      </h3>
      <div class="row">
        <div class="col-md-4">
          <span> {{ 'Quotation' | translate }}:</span>
          <input class="form-control" formControlName="invoice" readonly />
          @if (textValid('invoice')) {
            <span class="form-text text-danger">{{
              'Quotation' | translate
            }}</span>
          }
        </div>
        <div class="col-md-4">
          <span> {{ 'Driver' | translate }}:</span>
          <input
            class="form-control"
            placeholder="{{ 'Type the driver`s name' | translate }}"
            formControlName="chofer"
          />
          @if (textValid('chofer')) {
            <span class="form-text text-danger">{{
              'Name of driver required' | translate
            }}</span>
          }
        </div>
        <div class="col-md-4">
          <span> C.I.N:</span>
          <input
            class="form-control"
            placeholder="{{ 'Type the driver`s C.I.N' | translate }}"
            formControlName="cin"
          />
          @if (textValid('cin')) {
            <span class="form-text text-danger">{{
              'C.I.N of driver required' | translate
            }}</span>
          }
        </div>
        <div class="col-md-4">
          <span> {{ 'Plate' | translate }}:</span>
          <input
            class="form-control"
            placeholder="{{ 'Type the driver`s plate' | translate }}"
            formControlName="placa"
          />
          @if (textValid('placa')) {
            <span class="form-text text-danger">{{
              'Plate of driver required' | translate
            }}</span>
          }
        </div>
        <div class="col-md-4">
          <span> {{ 'Rasda Permit' | translate }}:</span>
          <input
            class="form-control"
            placeholder="{{ 'Type the driver`s rasda permit' | translate }}"
            formControlName="permiso_rasda"
          />
          @if (textValid('permiso_rasda')) {
            <span class="form-text text-danger">{{
              'Rasda Permit of driver required' | translate
            }}</span>
          }
        </div>
        <div class="col-md-4">
          <span> {{ 'Destination' | translate }}:</span>
          <input
            class="form-control"
            placeholder="{{ 'Type the destination' | translate }}"
            formControlName="destino"
          />
          @if (textValid('destino')) {
            <span class="form-text text-danger">{{
              'Destination required' | translate
            }}</span>
          }
        </div>
        <div class="col-md-4">
          <span> {{ 'Net Weight' | translate }}:</span>
          <input
            class="form-control"
            placeholder="{{ 'Type the net weight' | translate }}"
            formControlName="peso_neto"
          />
          @if (textValid('peso_neto')) {
            <span class="form-text text-danger">{{
              'Net Weight required' | translate
            }}</span>
          }
        </div>
        <div class="col-md-4">
          <span> {{ 'Exchange rate' | translate }}:</span>
          <input
            class="form-control"
            placeholder="{{ 'Type the exchange rate' | translate }}"
            formControlName="tasa_c"
            (keyup)="calculation()"
          />
          @if (textValid('tasa_c')) {
            <span class="form-text text-danger">{{
              'Exchange rate required' | translate
            }}</span>
          }
        </div>
        <div class="col-md-4">
          <span> {{ 'ARE' | translate }}:</span>
          <textarea
            class="form-control"
            placeholder="{{
              'Type the totals in letters for the invoice' | translate
            }}"
            formControlName="son"
            id=""
            cols="2"
            rows="2"
          ></textarea>
          @if (textValid('son')) {
            <span class="form-text text-danger">{{
              'ARE required' | translate
            }}</span>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <form>
            <span>{{ 'Send to' | translate }}:</span>
            <input
              class="form-control"
              [(ngModel)]="deliveryTxt"
              type="text"
              name="deliveryTxt"
              autocomplete="off"
            />
          </form>
        </div>
      </div>
      <div
        id="center-responsive"
        class="row"
        style="padding-left: 20px; margin-top: 10px"
      >
        <div class="col-md-2">
          <button (click)="validation(2)" mat-raised-button>
            {{ 'Register' | translate }}
          </button>
        </div>
        <div class="col-md-3">
          <button mat-raised-button [mat-dialog-close]>
            {{ 'Cancel' | translate }}
          </button>
        </div>
        <div class="col-md-2">
          <p>{{ 'Dollars' | translate }}:</p>
          <strong>{{ dollars | currency: 'USD' }}</strong>
        </div>
        <div class="col-md-2">
          <p>{{ 'Bolivars' | translate }}:</p>
          <strong>{{ calcDevise | currency: 'Bs' : 'symbol' }}</strong>
        </div>
      </div>
    </form>
  }
</mat-dialog-content>
